import React from 'react';
import { Link } from 'react-router-dom';

interface DropdownOption {
  value: string;
  label: string;
  link: string;
}

interface DropdownProps {
  options: DropdownOption[];
  onClick?: () => void;
  onLogout?: () => void;
  isLoading?: boolean;
}

const CustomSelect: React.FC<DropdownProps> = ({
  options,
  onClick,
  onLogout,
  isLoading = false,
}) => (
  <div className="absolute z-50 left-0 hidden group-hover:block bg-white text-black border border-gray-300 rounded-lg w-40">
    <ul className="py-2">
      {options.map((option) => (
        <li key={option.value} className="px-4 py-2 hover:bg-gray-100">
          {option.label === 'Logout' ? (
            <button
              onClick={() => {
                onLogout?.();
                onClick?.();
              }}
              className="block w-full text-center text-[16px] bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-3 rounded transition-colors duration-200 flex items-center justify-center space-x-2"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Logging out...</span>
                </>
              ) : (
                <>
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                  <span>{option.label}</span>
                </>
              )}
            </button>
          ) : (
            <Link
              to={option.link}
              className="block text-center text-[16px]"
              onClick={onClick}
            >
              {option.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default CustomSelect;
